import { UPLOAD_POLICIES, UPLOAD_PURPOSE_TENANT_LOGO } from "@nexus/contracts";

const TENANT_LOGO_POLICY = UPLOAD_POLICIES[UPLOAD_PURPOSE_TENANT_LOGO];

export const TENANT_LOGO_ACCEPT = TENANT_LOGO_POLICY.allowedContentTypes.join(",");

export function getTenantLogoMaxBytes(contentType: string): number | undefined {
  return TENANT_LOGO_POLICY.maxSizeBytesByContentType[contentType];
}

export function isAllowedTenantLogoType(contentType: string): boolean {
  return TENANT_LOGO_POLICY.allowedContentTypes.includes(contentType);
}
